import { authGuard, permissionGuard } from '@abp/ng.core';
import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./CBD/cbd').then(m => m.Cbd),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'account',
    loadChildren: () => import('@volo/abp.ng.account/public').then(c => c.createRoutes()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(c => c.createRoutes()),
  },
  {
    path: 'language-management',
    loadChildren: () =>
      import('@volo/abp.ng.language-management').then(c => c.createRoutes()),
  },
  {
    path: 'saas',
    loadChildren: () => import('@volo/abp.ng.saas').then(c => c.createRoutes()),
  },
  {
    path: 'audit-logs',
    loadChildren: () => import('@volo/abp.ng.audit-logging').then(c => c.createRoutes()),
  },
  {
    path: 'setting-management',
    loadChildren: () => import('@abp/ng.setting-management').then(c => c.createRoutes()),
  },

  // Zendra Services
  {
    path: 'general',
    loadChildren: () =>
      import('../../../general/src/app/general.routes').then(m => m.default),
  },
  {
    path: 'controlling',
    loadChildren: () =>
      import('../../../controlling/src/app/controlling.routes').then(m => m.default),
  },
  {
    path: 'planning',
    loadChildren: () =>
      import('../../../planning/src/app/planning.routes').then(m => m.default),
  },
  {
    path: 'wood-supply',
    loadChildren: () =>
      import('../../../woodsupply/src/app/wood-supply.routes').then(m => m.default),
  },
  {
    path: 'wood-security',
    loadChildren: () =>
      import('../../../woodsecurity/src/app/wood-security.routes').then(m => m.default),
  },

  // Demos
  {
    path: 'demo/generic-form',
    loadComponent: () => import('../demos/form-demo/form-demo').then(m => m.FormDemo),
  },
  {
    path: 'demo/table',
    loadComponent: () => import('../demos/table-demo/table-demo').then(m => m.TableDemo),
  },
  {
    path: 'demo/styles',
    loadComponent: () =>
      import('../demos/styles-demo/styles-demo').then(m => m.StylesDemo),
  },
  {
    path: 'demo/other-actions',
    loadComponent: () =>
      import('../demos/other-actions-demo/other-actions-demo').then(m => m.OtherActionsDemo),
  },
  { path: 'orchestrator', loadChildren: () => import('orchestrator').then(m => m.OrchestratorModule.forLazy()) }];
